import { render, staticRenderFns } from "./EditMirageTpl.vue?vue&type=template&id=4fdb1485&"
import script from "./EditMirageTpl.vue?vue&type=script&lang=js&"
export * from "./EditMirageTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports